import { IEmbedConfiguration } from 'powerbi-client';

import { OrganizationId } from 'yeself-common/typings/application/Application';

export const FETCH_REPORT_CONFIGURATION_REQUEST = 'analytics/FETCH_REPORT_CONFIGURATION_REQUEST';
export const FETCH_REPORT_CONFIGURATION_SUCCESS = 'analytics/FETCH_REPORT_CONFIGURATION_SUCCESS';
export const FETCH_REPORT_CONFIGURATION_FAIL = 'analytics/FETCH_REPORT_CONFIGURATION_FAIL';
export const RESET_ANALYTICS_STATE = 'analytics/RESET_ANALYTICS_STATE';

export type AnalyticsState = {
    isLoading: boolean;
    isFailed: boolean;
    reportConfiguration: ReportConfiguration;
    organizationId: string;
};

export type ReportConfiguration = {
    report: EmbeddableConfiguration;
    excludedPages: string[];
};

export interface EmbeddableConfiguration extends IEmbedConfiguration {
    expiration?: number;
}

type FetchReportConfigurationRequestAction = {
    type: typeof FETCH_REPORT_CONFIGURATION_REQUEST;
    payload: OrganizationId;
};

type FetchReportConfigurationSuccessAction = {
    type: typeof FETCH_REPORT_CONFIGURATION_SUCCESS;
    payload: ReportConfiguration;
};

type FetchReportConfigurationFailAction = {
    type: typeof FETCH_REPORT_CONFIGURATION_FAIL;
};

type ResetAnalyticsStateAction = {
    type: typeof RESET_ANALYTICS_STATE;
};

export type AnalyticsActionTypes =
    | FetchReportConfigurationRequestAction
    | FetchReportConfigurationSuccessAction
    | FetchReportConfigurationFailAction
    | ResetAnalyticsStateAction;
